import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { createThunkErrorHandler } from '../../utils/handleThunkError.js';
import { handlePending } from '../../utils/handlePending.js';
import { getAll, getAllCoin } from '../../http/gameAPI.js';

export const getGames = createAsyncThunk(
    'games/getGames',
    async function (params = {}, { rejectWithValue, dispatch, getState }) {
        
        dispatch(clearErrors())
        const state = getState().games;
        const page = params.page ?? state.page;
        const limit = params.limit ?? state.limit;
        const filters = params.filters ?? state.filters;
        try {
            const data = await getAll(page, limit, filters)
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Failed')
        }
    }
)

export const getGamesCoin = createAsyncThunk(
    'games/getGamesCoin',
    async function (params = {}, { rejectWithValue, dispatch, getState }) {
        
        dispatch(clearErrors())
        const state = getState().games.coin;
        const page = params.page ?? state.page;
        const limit = params.limit ?? state.limit;
       
        try {
            const data = await getAllCoin(page, limit)
            return data
        } catch (e) {
            return rejectWithValue(e?.code || 'Failed')
        }
    }
)

const gameSlice = createSlice({
    name: 'games',
    initialState: {
        errors: {},
        globalError: null,
        isLoading: false,
        isDataLoading: false,
        count: 0,
        limit: 24,
        page: 1,
        filters: {
            platform: null,
            region: null,
        },
        data: [],
        coin: {
            data: [],
            count: 0,
            limit: 24,
            page: 1,
            isLoading: false,
            isDataLoading: false,
        }

    },
    reducers: {
        clearErrors: (state) => {
            state.errors = {}
            state.globalError = null
        },

        clearGlobalError: (state) => {
            state.globalError = null
        },

        setPageGames(state, action) {
            const { page } = action.payload;
            state.page = page;
        },

        setPageGamesCoin(state, action) {
            const { page } = action.payload;
            state.coin.page = page;
        }
    },

    extraReducers: builder => {
        builder

            .addCase(getGames.rejected, createThunkErrorHandler("GAMES"))
            .addCase(getGames.pending, handlePending)
            .addCase(getGames.fulfilled, (state, action) => {
                console.log(action.payload)
                state.isLoading = false
                state.data = action.payload.data
                state.count = action.payload.count
                state.errors = {}
            })

            .addCase(getGamesCoin.rejected, createThunkErrorHandler("GAMES"))
            .addCase(getGamesCoin.pending, handlePending)
            .addCase(getGamesCoin.fulfilled, (state, action) => {
                state.coin.isLoading = false
                state.coin.data = action.payload.data
                state.coin.count = action.payload.count
                state.coin.errors = {}
            })

    }
});

export const {
    clearErrors,
    clearGlobalError,
    setPageGames,
    setPageGamesCoin
} = gameSlice.actions;

export default gameSlice.reducer;